import React from 'react';
import Image from '../../../../../components/elements/Image';

import styles from './Brands.module.css';

const Brands = () => {
  return (
    <div className="container m-0 p-0">
      <div className={`${styles.brandContainer} row d-flex justify-content-between align-items-center`}>
        <div>
          <Image name="use_01" className={styles.brandImage01} />
        </div>
        <div>
          <Image name="use_02" className={styles.brandImage02} />
        </div>
        <div>
          <Image name="use_03" className={styles.brandImage03} />
        </div>
        <div>
          <Image name="use_04" className={styles.brandImage04} />
        </div>
        <div>
          <Image name="use_05" className={styles.brandImage05} />
        </div>
        <div>
          <Image name="use_06" className={styles.brandImage06} />
        </div>
      </div>
    </div>
  );
};

export default Brands;
